import type { FC } from 'react';

import { Divider as SparkyDivider } from '@eneco/sparky';

const Divider: FC = () => {
  return <SparkyDivider emphasis="low" weight="regular" />;
};

export { Divider };
export default Divider;
